import { Dialog } from "@headlessui/react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setExpirationModal } from "../../redux/actions/authentication";
import { IKImage } from "imagekitio-react";

export default function TokenExpiredModal() {
  const setExpirationToken = useSelector((store) =>
    store?.authentication?.set_expiration_token
      ? store?.authentication?.set_expiration_token
      : false,
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (setExpirationToken) {
      navigate("/courses");
    }
  }, [setExpirationToken]);

  return (
    <div>
      <div>
        <Dialog
          open={setExpirationToken}
          onClose={() => dispatch(setExpirationModal(false))}
          as="div"
          style={{ zIndex: "9999999999" }}
          className="fixed inset-0 z-10 -mt-10 flex flex-col items-center justify-center overflow-y-auto md:mt-20 md:justify-start"
        >
          <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-70" />
          <Dialog.Title />
          <Dialog.Description />
          <div className="z-10 flex h-[23rem] w-5/6 flex-col items-center justify-between rounded-2xl bg-white py-4 px-4 text-center shadow-2xl md:h-[23rem] md:w-2/3 md:p-4 lg:w-[23rem]">
            <img
              urlEndpoint="https://img.learntube.ai/public-assets/"
              src={`https://img.learntube.ai/public-assets/homepage-banner/sessionExpired.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1666349694983`}
              className="h-2/4 w-2/4"
              transformation={[
                {
                  height: "260",
                  width: "260",
                },
              ]}
            />
            <h2 className="text-xl font-bold">Your Session has Expired</h2>
            <p>
              Your session has expired. Click okay to return to the login
              screen.
            </p>
            <button
              className="rounded-3xl bg-[#13A0BD] px-5 py-2 text-sm text-white md:text-base"
              onClick={() => dispatch(setExpirationModal(false))}
            >
              Okay
            </button>
          </div>
        </Dialog>
      </div>
    </div>
  );
}
